import React, { useState } from 'react'
import image from '../../assets/Images/LoginImage.png'
import SoilDoctorLogo from '../../assets/Images/SoilDoctorLogo.png'
import { Formik, Field } from 'formik'
import { Col, Form, Row, Spinner } from 'react-bootstrap'
import * as Yup from 'yup'
import { FaSpinner } from 'react-icons/fa'

// for form validation
const schema = Yup.object({
    oldPassword: Yup.string().required('Old password is required'),
    newPassword: Yup.string().required('New Password is requried')
})

function generateClassName(errors, touched, fieldName) {
    const hasError = errors[fieldName] && touched[fieldName];
    const isSuccess = touched[fieldName];
    return `form-control ${hasError ? 'border-2 border-danger' : isSuccess ? 'border-2 border-success' : ''}`;
}

const ResetPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        error: '',
        success: ''
    });

    return (
        <Formik
            initialValues={{
                oldPassword: '',
                newPassword: '',
            }}
            validationSchema={schema}
            onSubmit={async (values, { resetForm }) => {
                setIsLoading(true);
                setMessage({ error: '', success: '' });
                console.log(values);

                setTimeout(() => {
                    setIsLoading(false);
                    setMessage({ success: 'Password reset successfully!', error: '' });
                    resetForm();
                }, 2000);
            }}
        >
            {({ values, handleChange, handleSubmit, errors, touched }) => (

                <div className={`login-container m-0  ${window.innerWidth <= 768 ? 'py-4' : 'py-0'}`}>
                    {/* Left content */}
                    <div className="login-left">
                        <div className="logo">
                            <img src={SoilDoctorLogo} alt="Logo" width="250px" />
                        </div>
                        <div className="left-content">
                            <h1 className="fw-bolder mb-3">Welcome to Soil Doctor! </h1>
                            <img src={image} alt="Background" className="responsive-image" />
                            <figure className="w-75">
                                <blockquote className="blockquote">
                                    <h3>To forget how to dig the earth and to tend the soil is to forget ourselves.</h3>
                                </blockquote>
                                <figcaption className="blockquote-footer">
                                    <cite title="Source Title">Mohandas K. Gandhi</cite>
                                </figcaption>
                            </figure>
                        </div>
                    </div>

                    {/* Right content */}
                    <div className="login-right">
                        <div className="login-form" contentEditable={false}>

                            <Form className="form__details" onSubmit={handleSubmit} onChange={handleChange}>
                                <h3 className="pt-4 pb-0">Reset Password</h3>

                                {message.error && <div className="alert alert-danger mt-3">{message.error}</div>}
                                {message.success && <div className="alert alert-success mt-3">{message.success}</div>}

                                <Row className="my-4">

                                    {/* old password */}
                                    <Form.Group as={Col} md="12" className="group">
                                        <div className="form-floating">
                                            <Field
                                                type="password"
                                                name="oldPassword"
                                                value={values.oldPassword}
                                                placeholder="Old Password"
                                                className={generateClassName(errors, touched, 'oldPassword')}
                                                onChange={handleChange} />
                                            <Form.Label htmlFor="oldPassword">Old Password <span className="text-danger">&nbsp;*</span></Form.Label>
                                        </div>
                                        {errors.oldPassword && touched.oldPassword ? (<div className="form_errors"> &#9888; {errors.oldPassword}</div>) : null}
                                    </Form.Group>

                                    {/* new password */}
                                    <Form.Group as={Col} md="12" className="group">
                                        <div className="form-floating">
                                            <Field
                                                type="password"
                                                name="newPassword"
                                                value={values.newPassword}
                                                placeholder="New Password"
                                                className={generateClassName(errors, touched, 'newPassword')}
                                                onChange={handleChange} />
                                            <Form.Label htmlFor="newPassword">New Password <span className="text-danger">&nbsp;*</span></Form.Label>
                                        </div>
                                        {errors.newPassword && touched.newPassword ? (<div className="form_errors"> &#9888; {errors.newPassword}</div>) : null}
                                    </Form.Group>

                                </Row>

                                <div className="my-3 col col-md-6 mx-auto">
                                    {/* Submit button */}
                                    <button type="submit" className="w-100 text-center btn btn-dark" disabled={isLoading}>
                                        {isLoading && <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
                                        <span>{' '}Submit</span>
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </div>

                    {isLoading && (
                        <div className="loading-overlay">
                            <FaSpinner className="loading-icon spin" />
                        </div>
                    )}
                </div>)
            }

        </Formik>
    )
}

export default ResetPassword